import { Spinner } from "@chakra-ui/react"
import { GetGranularityConfiguration, Granularity } from "@hydrologiq/common/types/reporting/Granularity"
import { useQueryWithEndpoint } from "@hydrologiq/shared/hooks/useGraphQLClient"
import * as gqlTypes from "@hydrologiq/gql-experience/graphql"
import { IANATimeZone, toTimestamp } from "@hydrologiq/common/helpers/date"
import { DateTime } from "timezonecomplete"
import Download from "@hydrologiq/shared/reporting/Download"
import { usageCsv, type RowType } from "@hydrologiq/shared/reporting/usageCsv"

interface AssetUsageDownloadProps {
  start: DateTime
  end: DateTime
  granularity: Granularity
  asset: string
  assetName: string
  callback?: () => void
  selectedFields?: (keyof RowType)[]
}

function AssetUsageDownload({
  start,
  end,
  asset,
  granularity,
  assetName,
  callback,
  selectedFields,
}: AssetUsageDownloadProps) {
  const granularityConfig = GetGranularityConfiguration(granularity)

  const { loading, error, data } = useQueryWithEndpoint(
    gqlTypes.AssetUsageDocument,
    {
      variables: {
        id: asset,
        start: toTimestamp(start, true),
        end: toTimestamp(end, true),
        freq: granularityConfig.queryFrequency,
        location: IANATimeZone(),
      },
    },
    "primary" // Use the primary (experience API) endpoint
  )

  if (loading) return <Spinner />
  if (error || !data) return "An error has occurred: " + error?.message

  return (
    <Download
      start={start}
      end={end}
      granularity={granularity}
      baseName={assetName}
      callback={callback}
      data={usageCsv(data.getAssetUsage?.data || [], selectedFields)}
    />
  )
}

export default AssetUsageDownload
